import { useEffect } from 'react';
import Lenis from 'lenis';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Brands from './components/Brands';
import Collections from './components/Collections';
import Inspiration from './components/Inspiration';
import Enquiry from './components/Enquiry';
import Showroom from './components/Showroom';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import './App.css';

function App() {
  useEffect(() => {
    // Initialize Lenis smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-stone-white min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Brands />
        <Collections />
        <Inspiration />
        <Enquiry />
        <Showroom />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
